import { render, staticRenderFns } from "./skill-comparer.vue?vue&type=template&id=86c7e89e&"
import script from "./skill-comparer.vue?vue&type=script&lang=js&"
export * from "./skill-comparer.vue?vue&type=script&lang=js&"
import style0 from "./skill-comparer.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports